import React from 'react';
import Stack from './Stack/Stack';


function App() {
  return (
    <div className="App">
      <Stack />
    </div>
  );
}

export default App;
